import PeopleIcon from '@mui/icons-material/People';

export default PeopleIcon;
